import React from "react"
import { FormattedMessage } from "react-intl"
import { Select } from "antd"
import { useLocalization } from "../../../app/localization"
import { localize } from "../../utils/localize"
import { miniLanguages } from "../../constants/ui-languages"
import styles from "./app-language.module.css"

const { Option } = Select

export const AppLanguage = ({ search }) => {
	const { uiLanguage, setUiLanguage } = useLocalization()
	const selectedLanguageCode = uiLanguage?.toLowerCase() || "en"
	const normalizedLanguages = (miniLanguages || []).map((language) => {
		const code = language.code?.toLowerCase()

		return { ...language, code, label: language.text }
	})

	return (
		<div className={styles.language_block} id="language-menu">
			<div>
				<FormattedMessage id="language" />
				:
			</div>
			<Select
				aria-label={localize("Language")}
				id="languageSelect"
				showSearch={search}
				value={selectedLanguageCode}
				onChange={(language) => setUiLanguage(language)}
				className={`${styles.language_dropdown} custom-simple-dropdown`}
				dropdownMatchSelectWidth={170}
				filterOption={
					(input, option) => option.children.toLowerCase().startsWith(input.toLowerCase())
				}
			>
				{normalizedLanguages.map(language => (
					<Option
						key={language.code}
						value={language.code}
					>
						{language.label}
					</Option>
				))}
			</Select>
		</div>
	)
}
